"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _clientEnvVariables = _interopRequireDefault(require("./clientEnvVariables"));
var _default = exports["default"] = {
  routes: null,
  debugMode: false,
  personalizationFlipperName: null,
  disableInlinePageCallFlipperName: 'global-disable-inline-page-call',
  gtmCode: _clientEnvVariables["default"].CONFIG === 'prod' ? 'GTM-TK7B6ZX' : 'GTM-MW9FSRH',
  pixallUrl: _clientEnvVariables["default"].CONFIG === 'prod' ? 'https://www.kbb.com/pixall/pix-kbb.min.js' : 'https://staging.kbb.com/pixall/pix-kbb.min.js',
  basePubmaticUrl: 'https://ads.pubmatic.com/AdServer/js/pwt/157461/',
  gptUrl: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
  prebidUrl: 'https://c.amazon-adsystem.com/aax2/apstag.js',
  enableGoogleAnalytics: false,
  enableInlinePixall: false,
  enableUserInfo: true,
  partyTownFlipperName: null,
  partytown: {
    loadScriptsOnMainThread: ['https://t.contentsquare.net/uxa/db279cdd0f9c3.js', 'https://gateway.foresee.com/sites/kbb-com/production/gateway.min.js', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js', 'https://ws.audioeye.com/ae.js', 'https://static.ads-twitter.com/uwt.js'],
    forward: ['dataLayer.push'],
    proxyDomain: _clientEnvVariables["default"].PARTY_TOWN_PROXY_DOMAIN,
    lib: _clientEnvVariables["default"].PARTY_TOWN_LIB,
    debug: _clientEnvVariables["default"].PARTY_TOWN_DEBUG
  },
  preloadScripts: false,
  isHomepage: false,
  enableGPT: true,
  enablelaunch: true,
  enableGtm: true,
  loadForesee: true,
  userApiUrl: ''
};